define([
    "./occurrenceCategoryModule",
    "./occurrenceCategoryRouter",
    "./search/OccurrenceCategorySearchController",
    "./edition/OccurrenceCategoryEditionController",
    "./occurrenceCategoryService"
], function () {
});